






















































/**
 * "short" notice about what is going on with setting the rin-redirect entry in SessionStorage
 * original implementation had a span with click modifiers (.ctrl.exact, .left.exact & .middle.exact) that called a goToLogin function
 * this function accepted 2 parameters - if the click should trigger a new window or redirect in the current one and a link where to redirect to
 * the LoginService exposed a goToLogin function that - depending on the boolean status for where to open the login - acted accordingly
 * this function also set the session storage rin-redirect entry before doing everything else
 *
 * due to a11y (accessibility) keyboard navigation was not doable with this span in an expected manner
 * to make sure keyboard navigation works as intended (and screenreaders can inform the user about where he is going to get redirected) the span is replaced by an a href
 * the a href has one click modifier (@click.exact) which sets the session storage entry
 * the click modifier is triggered by a direct click or pressing enter on the keyboard when focus is on the a href
 * middle click or ctrl click do not trigger the click modifier and open the login page in a new tab, without the rin-redirect session storage entry
 */

import Vue from 'vue';
import { IIcons } from '@/common/interfaces/index.interface';
import { IMenus, IMyAccountMenuItem } from '@/common/interfaces/header.interface';
import CustomerHelper from '@/helpers/CustomerHelper';
import A11yHelper from '../../../helpers/A11yHelper';
import AppHelper from '../../../helpers/AppHelper';
import SessionStorageHelper from '../../../helpers/SessionStorageHelper';

interface IMyAccountComponent {
  $refs?: {
    myAccountDropdownWrapper?: HTMLDivElement;
  };
  AppHelper: typeof AppHelper;
  SessionStorageHelper: typeof SessionStorageHelper;
  clearPointerEventsTimeout: number;
  showLoggedInSubMenuViaKeyboardNavigation: boolean;
  subMenuItems: IMyAccountMenuItem[];
}

export default Vue.extend({
  name: `MyAccount`,
  data(): IMyAccountComponent {
    return {
      AppHelper,
      SessionStorageHelper,
      clearPointerEventsTimeout: -1,
      showLoggedInSubMenuViaKeyboardNavigation: false,
      subMenuItems: [],
    };
  },
  props: {
    icons: {
      required: true,
      type: Object as () => IIcons,
    },
    isPartner: {
      required: true,
      type: Boolean,
    },
    loading: {
      required: true,
      type: Boolean,
    },
    loggedIn: {
      required: true,
      type: Boolean,
    },
    loginLink: {
      required: true,
      type: String,
    },
    menus: {
      required: true,
      type: Object as () => IMenus,
    },
  },
  methods: {
    assembleAccountItems(): void {
      if(this.menus.loginAndCart.length === 0 || this.menus.loginAndCart.length === 0) {
        return;
      }

      let itemsToAssemble = this.isPartner
        ? this.menus.loginAndCart[0].children
        : this.menus.loggedInCustomer[0].children;

      // Remove 'Logout' Item.
      itemsToAssemble = itemsToAssemble.filter(item => item[0].delegate !== `logout`);

      this.subMenuItems = itemsToAssemble.map(item => {
        return {
          link: item[0].link,
          title: item[0].title,
        };
      });
    },
    focusOut(e: FocusEvent | null): void {
      this.showLoggedInSubMenuViaKeyboardNavigation = A11yHelper.isFocusWithinCurrentGroup(e);
    },
    logout(): void {
      CustomerHelper.logout();
      window.location.href = `/`;
    },
    mouseEnter(): void {
      window.clearTimeout(this.clearPointerEventsTimeout);
      if(this.$refs.myAccountDropdownWrapper) {
        this.$refs.myAccountDropdownWrapper.style.display = `flex`;
        this.$refs.myAccountDropdownWrapper.style.pointerEvents = `auto`;
      }
    },
    mouseLeave(): void {
      this.clearPointerEventsTimeout = window.setTimeout(() => {
        if(this.$refs.myAccountDropdownWrapper) {
          this.$refs.myAccountDropdownWrapper.style.display = `none`;
          this.$refs.myAccountDropdownWrapper.style.pointerEvents = `none`;
        }
      }, 250);
    },
  },
  watch: {
    menus: {
      deep: true,
      handler(): void {
        this.assembleAccountItems();
      },
      immediate: true,
    },
  },
});
